import r1LogoUrl from "@/assets/r1-logo.svg";
import { externalLinkProps, siteLinks } from "@/config/branding";

interface BrandProps {
  compact?: boolean;
}

/** RequirementONE wordmark using the official R1 logo mark. */
export function Brand({ compact }: BrandProps) {
  return (
    <a
      href={siteLinks.companyWebsite}
      className="flex items-center gap-2.5 text-ink no-underline hover:opacity-90"
      {...externalLinkProps}
    >
      <img
        src={r1LogoUrl}
        alt="RequirementONE"
        className="h-8 w-auto"
        width={32}
        height={32}
      />
      {!compact ? (
        <span className="text-sm font-semibold tracking-tight">RequirementONE</span>
      ) : null}
    </a>
  );
}
